import { Link } from "react-router-dom";
import { Shield } from "lucide-react";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="border-t border-white/10 bg-[#050608]">
            <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
                <div>
                    <div className="flex items-center gap-2 mb-3">
                        <div className="w-8 h-8 border border-volt flex items-center justify-center hud-brackets">
                            <Shield className="w-4 h-4 text-volt" />
                        </div>
                        <span className="font-oswald font-bold text-lg tracking-widest uppercase">
                            SIX<span className="text-volt">CLICK</span>
                        </span>
                    </div>
                    <p className="text-sm text-[#94a3b8] leading-relaxed">
                        Tactical intelligence for the deals that matter. Built for service members, veterans, and their families.
                    </p>
                </div>
                <div>
                    <div className="mono-label mb-3">Navigate</div>
                    <ul className="space-y-2">
                        <li><Link to="/browse" className="text-sm hover:text-volt">Browse discounts</Link></li>
                        <li><Link to="/submit" className="text-sm hover:text-volt">Submit a discount</Link></li>
                        <li><Link to="/about" className="text-sm hover:text-volt">How it works</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="mono-label mb-3">Coverage</div>
                    <ul className="space-y-2 text-sm text-[#94a3b8]">
                        <li>Restaurants · Retail</li>
                        <li>Travel · Entertainment</li>
                        <li>Auto · Home services</li>
                        <li>Fitness · Freebies</li>
                    </ul>
                </div>
                <div>
                    <div className="mono-label mb-3">Notice</div>
                    <p className="text-xs text-[#64748b] leading-relaxed">
                        Discounts subject to change at merchant&apos;s discretion. Always verify with the business before purchase. Not affiliated with any branch of the U.S. Armed Forces.
                    </p>
                </div>
            </div>
            <div className="border-t border-white/10 px-4 md:px-8 py-4 text-center mono-label text-[10px] text-[#64748b]">
                © {new Date().getFullYear()} SIXCLICK · Serving those who serve.
            </div>
        </footer>
    );
}
